import { Slot } from '@radix-ui/react-slot';
import { motion } from 'framer-motion';

export const AnimatedSlot = motion(Slot);
